var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scout-topic-panel",
    {
      attrs: {
        title: "送信候補",
        name: "review",
        tooltip:
          "貴社がスカウトの送信を検討している会員を一時保存することができます。",
        "data-test": "panel-review",
      },
    },
    [
      _c(
        "router-link",
        {
          staticClass: "pega-text-link",
          attrs: {
            to: {
              name: "scoutCandidate",
              params: { contractId: _vm.contractId, jobId: _vm.jobId + "" },
            },
          },
        },
        [
          _c(
            "span",
            {
              staticClass: "boss-scoutandlike-text",
              attrs: { "data-test": "count" },
            },
            [_vm._v(_vm._s(_vm.count) + "名\n    ")]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }